<template>
  <header class="login-header">
    <!-- Section 1 (40%): Branding - Clarity Logo -->
    <div class="login-header__section login-header__section--branding">
      <div class="login-header__logo login-header__logo--clarity">
        <img :src="clarityLogo" alt="Clarity Portal" />
      </div>
    </div>

    <!-- Section 2 (60%): Reserved space for future content -->
    <div class="login-header__section login-header__section--content">
      <!-- Future: Navigation, user info, or other header content -->
    </div>
  </header>
</template>

<script setup>
const props = defineProps({
  clarityLogo: {
    type: String,
    required: true
  }
})
</script>

<style scoped>
.login-header {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 1.5rem 3rem;
  background: rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
}

/* Section layout */
.login-header__section {
  display: flex;
  align-items: center;
}

.login-header__section--branding {
  flex: 0 0 40%;
  gap: 2rem;
}

.login-header__section--content {
  flex: 0 0 60%;
  justify-content: flex-end;
}

/* Logo styling */
.login-header__logo {
  max-height: 60px;
  flex-shrink: 0;
}

.login-header__logo img {
  height: 100%;
  max-height: 70px;
  width: auto;
  display: block;
}
.login-header__logo-placeholder,
.login-header__logo-loading {
  background: white;
  padding: 1rem 1.5rem;
  border-radius: 4px;
  text-align: center;
  max-width: 300px;
}

.login-header__logo-loading {
  color: #4299e1;
  font-weight: 500;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.login-header__logo-placeholder span {
  display: block;
  font-size: 0.875rem;
  color: #333;
  line-height: 1.4;
}

.login-header__logo-placeholder-note {
  font-size: 0.75rem;
  color: #666;
  margin-top: 0.25rem;
}

@media (max-width: 1024px) {
  .login-header__section--branding {
    flex: 0 0 50%;
  }
  
  .login-header__section--content {
    flex: 0 0 50%;
  }
}

@media (max-width: 768px) {
  .login-header {
    flex-direction: column;
    padding: 1rem 1.5rem;
    gap: 1rem;
  }

  .login-header__section--branding,
  .login-header__section--content {
    flex: 1 1 100%;
    width: 100%;
    justify-content: center;
  }

  .login-header__section--branding {
    flex-direction: column;
    gap: 1rem;
  }

  .login-header__logo {
    max-height: 50px;
  }

  .login-header__logo-placeholder,
  .login-header__logo-loading {
    max-width: 100%;
  }
}
</style>